var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.958 2.352l1.085 0.296-3 11-1.085-0.296 3-11z"
  })));
};
export default SvgCode;